export default "__VITE_ASSET__CzZpciXW__"